import { useQuery } from 'react-query'
import { User, UserService } from '@ospace/auth'

export const useUsers = () => {
  return useQuery<User[]>('users', UserService.getUsers)
}
